const serviceTypes = [
  {
    id: 1,
    label: "Frio Pasivo",
    key: "Frío Pasivo",
  },
  //   {
  //     id: 2,
  //     label: "Frio Activo",
  //     value: "Frío Activo",
  //   },
  {
    id: 3,
    label: "Frio Proximidad",
    key: "Frío Proximidad",
  },
];

const products = [
  {
    id: 1,
    label: "Paq Frío",
    key: "FRAXQ-DOUAOF",
  },
  {
    id: 2,
    label: "Paq Farma",
    key: "FRAXS-DOUAOF",
  },
  {
    id: 3,
    label: "Paq Premium (Coldchain)",
    key: "PADXA-DOUAOF",
  },
];

module.exports = { serviceTypes, products };
